import NewSalesDebitNote from "../../../../components/@documents/sales_debit_notes/NewSalesDebitNote";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesDebitNoteNewPage() {

    return (
        <NewSalesDebitNote 
            routeType={routeTypes.admin}
        />
    )
}